<template>
    <span class="projectContent">
        <h1 class="projectTitle">
            Yangwang-1 Space Telescope Data Center
        </h1>
        <h2 class="projectSubTitle">
            A Web Platform for Showing Data Obtained by Yangwang-1 Satellite from the Origin Space Company
        </h2>
        <p>
            In collaboration with Zeyang Meng
        </p>
        <p>
            The animation is based on the real orbit data of the satellite.
        </p>
        <p>
            Screenshots:
        </p>
        <img style="width:70%" src="\ImgThumbNail\observer0.jpg"/>
        <img style="width:70%" src="\ImgThumbNail\observer2.jpg"/>
        <img style="width:70%" src="\ImgThumbNail\observer1.jpg"/>
        <br>
        <p>
            Live Videos:
        </p>
        <iframe width="60%" height="315" src="https://www.youtube.com/embed/Nzd00f4zRsA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <br>
        <iframe width="60%" height="315" src="https://www.youtube.com/embed/olX8RoZDtDA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </span>
  
</template>

<script>
export default {
    name:"SkyObserver"

}
</script>

<style>


</style>